import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_mof_doc_line_RowClass,
} from '../../../dbschema';

export class MofDocLineContainerModel extends BaseContainerModel {
  bl_aat_mof_doc_line: bl_aat_mof_doc_line_RowClass = new bl_aat_mof_doc_line_RowClass();
}
